<template>
  <transition name="cmp-slide">
    <div v-if="visivel" class="cmp-card">
      <p class="cmp-card-eyebrow">Passo 2 de {{ totalPassos }}</p>
      <h3 class="cmp-card-title">{{ isTeste ? "Destinatários de teste" : "Audiência" }}</h3>

      <!-- MODO TESTE -->
      <div v-if="isTeste">
        <label class="cmp-label">Enviar teste para:</label>
        <el-select
          :value="destinatariosTeste"
          multiple filterable
          placeholder="Selecionar contactos de teste"
          style="width:100%"
          @input="$emit('update:destinatariosTeste', $event)"
        >
          <el-option v-for="opt in opcoesContactos" :key="opt.label" :label="opt.label" :value="opt.value"/>
        </el-select>
        <p v-if="!destinatariosTeste || destinatariosTeste.length === 0" class="cmp-error">
          Seleciona pelo menos um destinatário de teste.
        </p>
      </div>

      <!-- MODO REAL -->
      <div v-else>
        <label class="cmp-label">Título da campanha</label>
        <base-input :value="titulo" placeholder="Ex: Promoção de verão..." class="mb-3"
          @input="$emit('update:titulo', $event)"/>
        <p v-if="!titulo || !titulo.trim()" class="cmp-error">O título é obrigatório.</p>

        <label class="cmp-label mt-2">Quem recebe?</label>
        <div class="cmp-choice-group mb-2">
          <div class="cmp-choice" :class="{ 'is-selected': enviarParaTodos }" @click="$emit('update:enviarParaTodos', true)">
            <div class="cmp-choice-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <div>
              <div class="cmp-choice-name">Todos os contactos</div>
              <div class="cmp-choice-desc">Envia para toda a base</div>
            </div>
            <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
          </div>

          <div class="cmp-choice" :class="{ 'is-selected': !enviarParaTodos }" @click="$emit('update:enviarParaTodos', false)">
            <div class="cmp-choice-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <circle cx="12" cy="12" r="6"/>
                <circle cx="12" cy="12" r="2"/>
              </svg>
            </div>
            <div>
              <div class="cmp-choice-name">Segmento específico</div>
              <div class="cmp-choice-desc">Escolhe um grupo de clientes</div>
            </div>
            <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
          </div>
        </div>

        <div v-if="!enviarParaTodos" class="cmp-sub-field">
          <label class="cmp-label">Segmento guardado</label>
          <el-select
            :value="filtroSelecionado"
            filterable placeholder="Escolher segmento..." style="width:100%"
            @change="$emit('mudar-filtro', $event)"
            @input="$emit('update:filtroSelecionado', $event)"
          >
            <el-option v-for="(f, i) in filtros" :key="i" :label="f.label" :value="f.id"/>
          </el-select>
          <div v-if="numClientes > 0" class="cmp-count-badge mt-2">
            <i class="ni ni-single-02"></i> {{ numClientes }} clientes vão receber esta campanha
          </div>
          <p v-else-if="filtroSelecionado && numClientes === 0" class="cmp-error">
            Este segmento não tem clientes.
          </p>
        </div>
      </div>

      <div class="cmp-actions">
        <base-button type="neutral" size="md" @click="$emit('recuar')">
          <i class="ni ni-bold-left mr-1"></i> Voltar
        </base-button>
        <base-button type="primary" size="md" :disabled="!valido" @click="$emit('avancar')">
          Continuar <i class="ni ni-bold-right ml-1"></i>
        </base-button>
      </div>
    </div>
  </transition>
</template>

<script>
import { Select, Option } from "element-ui";

export default {
  name: "CampanhaPasso2",
  components: { [Select.name]: Select, [Option.name]: Option },
  props: {
    visivel:            { type: Boolean, default: false },
    isTeste:            { type: Boolean, default: false },
    totalPassos:        { type: Number,  default: 4 },
    titulo:             { type: String,  default: "" },
    enviarParaTodos:    { type: Boolean, default: false },
    filtroSelecionado:  { default: null },
    filtros:            { type: Array,   default: () => [] },
    numClientes:        { type: Number,  default: 0 },
    destinatariosTeste: { type: Array,   default: () => [] },
    opcoesContactos:    { type: Array,   default: () => [] },
    valido:             { type: Boolean, default: false },
  },
};
</script>
